import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const MachineStyleSelection = (props) => {
  const {
    machineStyles,
    selectedMachineStyleDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedMachineStyle,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your machine style</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the style of machine you want to pair the device to</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-machine-style"
            getOptionLabel={(option) => option.displayValue ?? option}
            options={machineStyles}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
                onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Machine Style" />}
            value={selectedMachineStyleDisplay}
            isOptionEqualToValue={(option, value) => option.displayValue === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineStyle,
          })}
          disabled={!selectedMachineStyle}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineStyleSelection;
